import PropTypes from "prop-types";

export function Currency({ value }) {
  return Number(value).toLocaleString("en-US", { style: "currency", currency: "USD" });
}

Currency.propTypes = {
  value: PropTypes.any.isRequired,
};
